export const List = () => import("./List.vue");
export const Edit = () => import("./Edit.vue");
export const View = () => import("./View.vue");
export const Create = () => import("./Create.vue");
export const MiscPayment = () => import("./MiscPayment.vue");
export const PreSanctionBank = () => import("./PreSanctionBank.vue");
export const NoteSheetPayment = () => import("./NoteSheetPayment.vue");
export const PreSanctionPayment = () => import("./PreSanctionPayment.vue");
export const FinalBillSheetPayment = () => import("./FinalBillSheetPayment.vue");
